import {connect} from 'react-redux'
import {getCity} from '@/redux/modules/search/selectors'

export default (Component) =>
  connect((state) => ({currentCity: getCity(state)}))(Component)
